import React, { useState, useEffect, useMemo } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  CardHeader,
  Input,
} from "reactstrap";
import CommonTableNew from "../../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import { API } from "../../../api/API";
import { getData } from "../../../CommonElements/Functions/PostGetFun";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux-toolkit/store";
import { getFilteredPositionIds } from "../../../db/DexieServises";
//   PositionId: number;
//   CreatedAt: string;
//   UpdatedAt: string | null;
//   OnBoardingStatus: number;
//   StartDate: string | null;
//   EndDate: string | null;
//   Istateid: number | null;
//   SupportPositions: unknown;
// }

interface ActiveVacantResponse {
  totalTerritories: number;
  totalActiveTerritories: number;
  totalVacantTerritories: number;
  activeTerritories: TerritoryItem[];
}
interface TerritoryItem {
  TerritoryId: number | string;
  TerritoryName: string;
}

interface RCPASalePrescriptionApiItem {
  outlet_name?: string;
  mapped_user?: string;
  territory_name?: string;
  potential_value?: number | string;
}

interface MonthYear {
  month: string;
  year: string;
}

interface MonthRange {
  from: MonthYear;
  to: MonthYear;
}

interface DateRange {
  start: string;
  end: string;
}

interface TableRow {
  customerName: string;
  mappedemployee: string;
  territory: string;
  potentialValue: string;
}

const RCPAsalesprescription = () => {
  const [loading, setLoading] = useState(false);
  const serverUrl = localStorage.getItem("serverUrl");
  const positions = useSelector((state: RootState) => state.position.positions);
  const unitId = useSelector((state: RootState) => state.orgUnit.id);
  const [searchText, setSearchText] = useState("");
  const [tableData, setTableData] = useState<RCPASalePrescriptionApiItem[]>([]);
  const [territoryList, setTerritoryList] = useState<TerritoryItem[]>([]);
  const [selectedTerritoryId, setSelectedTerritoryId] = useState<string>("");
  const [monthlyData, setMonthlyData] = useState<string[]>([]);
  const [monthsList, setMonthsList] = useState<string[]>([]);
  const [dateRange, setDateRange] = useState<DateRange>({
    start: "",
    end: "",
  });
  const [monthModalOpen, setMonthModalOpen] = useState(false);
  console.log("========== tableData ==========", tableData);
  // console.log("========== activeVacantData ==========", activeVacantData);
  console.log("========== territoryList ==========", territoryList);

  const [monthRange, setMonthRange] = useState<MonthRange>({
    from: { month: "", year: "" },
    to: { month: "", year: "" },
  });
  const currentYear = new Date().getFullYear();
  const yearOptions = [currentYear, currentYear - 1, currentYear - 2];

  useEffect(() => {
    const RCPAsalePrescriptionData = async () => {
      try {
        if (!serverUrl) return;

        setLoading(true);

        const url = `${serverUrl}${API.RCPAsalePrescription}`;
        const { status, data: responseData } = await getData(url, true, {
          territory_id: selectedTerritoryId,
        });
        console.log(
          "=========== RCPAsalePrescriptionData ===========",
          url,
          responseData,
        );
        if (status === 200 && responseData?.data) {
          setTableData(responseData.data);
        }
      } catch (err) {
        console.error("Error fetching RCPA Sales & Prescription data:", err);
      } finally {
        setLoading(false);
      }
    };
    RCPAsalePrescriptionData();
  }, [selectedTerritoryId,serverUrl]);

  useEffect(() => {
    const getactiveVacantTerritories = async () => {
      try {
        if (!unitId) return;
        const positionIds =
          positions.length > 0
            ? positions.map((pos: any) => pos.id).join(",")
            : (await getFilteredPositionIds("Position", unitId)).join(",");

        const url = `${serverUrl}${API.activeVacantTerritories}`;
        const { status, data: responseData } = await getData(url, true, {
          position_id: positionIds,
        });
        console.log(
          "=========== getactiveVacantTerritories ===========",
          url,
          responseData,
        );
        if (status === 200 && responseData?.data) {
          setTerritoryList(responseData.data.activeTerritories);

        }
      } catch (err) {
        console.error("Error fetching active vacant territories data:", err);
      }
    };
    getactiveVacantTerritories();
  }, [positions, unitId, serverUrl]);

  const monthNumberToName: { [key: number]: string } = {
    1: "Jan",
    2: "Feb",
    3: "Mar",
    4: "Apr",
    5: "May",
    6: "Jun",
    7: "Jul",
    8: "Aug",
    9: "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };

  const nameToMonthNumber: { [key: string]: number } = {
    Jan: 1,
    Feb: 2,
    Mar: 3,
    Apr: 4,
    May: 5,
    Jun: 6,
    Jul: 7,
    Aug: 8,
    Sep: 9,
    Oct: 10,
    Nov: 11,
    Dec: 12,
  };

  const toggleMonthModal = () => setMonthModalOpen((prev: boolean) => !prev);

  const handleApplyDateRange = () => {
    if (
      monthRange.from.month &&
      monthRange.from.year &&
      monthRange.to.month &&
      monthRange.to.year
    ) {
      const fromMonthNum = nameToMonthNumber[monthRange.from.month];
      const toMonthNum = nameToMonthNumber[monthRange.to.month];
      setDateRange({
        start: `${fromMonthNum}-${monthRange.from.year}`,
        end: `${toMonthNum}-${monthRange.to.year}`,
      });
    }
    toggleMonthModal();
  };

  const getMonthRangeButtonLabel = () => {
    if (dateRange.start && dateRange.end) {
      const [startMonth, startYear] = dateRange.start.split("-");
      const [endMonth, endYear] = dateRange.end.split("-");
      return `${monthNumberToName[parseInt(startMonth, 10)]} ${startYear} - ${monthNumberToName[parseInt(endMonth, 10)]} ${endYear}`;
    }
    return "Select Month Range";
  };
  const columns = [
    {
      id: "1",
      head: "Customer Name",
      key: "customerName",
      sortKey: "customerName",
    },
    {
      id: "2",
      head: "Mapped Employee",
      key: "mappedemployee",
      sortKey: "mappedemployee",
    },
    {
      id: "3",
      head: "Territory",
      key: "territory",
      sortKey: "territory",
    },
    {
      id: "4",
      head: "Potential Value",
      key: "potentialValue",
      sortKey: "potentialValue",
    },
  ];

  const displayedData = useMemo<TableRow[]>(() => {
    if (!tableData?.length) return [];

    return tableData
      .map((item) => ({
        customerName: item.outlet_name ?? "-",
        mappedemployee: item.mapped_user ?? "-",
        territory: item.territory_name ?? "-",
        potentialValue:
          typeof item.potential_value === "number"
            ? item.potential_value.toLocaleString("en-IN")
            : (item.potential_value ?? "-").toString(),
      }))
      .filter((row) => {
        if (!searchText) return true;
        const search = searchText.toLowerCase();

        return (
          row.customerName.toLowerCase().includes(search) ||
          row.mappedemployee.toLowerCase().includes(search) ||
          row.territory.toLowerCase().includes(search)
        );
      });
  }, [tableData, searchText]);

  return (
    <div>
      <Card>
        <CardHeader>RCPA Sales & Prescription</CardHeader>
        <CardBody>
          <div className="col px-3 mb-3 d-flex align-items-center justify-content-between">
            <div className="col-md-8 d-flex align-items-center gap-3 flex-wrap">
              <Input
                type="text"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search by name or position"
                className="form-control"
                style={{ maxWidth: "250px" }}
              />
              <Input
                type="select"
                value={selectedTerritoryId || ""}
                onChange={(e) => setSelectedTerritoryId(e.target.value)}
                style={{ maxWidth: "220px" }}
              >
                <option value="">Select Territory</option>

                {Array.isArray(territoryList) &&
                  territoryList.map((item: TerritoryItem) => (
                    <option
                      key={`${item.TerritoryId}-${item.TerritoryName}`}
                      value={String(item.TerritoryId)}
                    >
                      {item.TerritoryName}
                    </option>
                  ))}
              </Input>
            </div>
            <div>

              {/* <Button color="info" onClick={toggleMonthModal} size="sm">
                {getMonthRangeButtonLabel()}
              </Button> */}
            </div>
          </div>

          <div className="table-responsive">
            {loading ? (
              <div className="text-center py-3">
                <div>
                  <Image
                    className="b-r-10 img-80"
                    src={dynamicImage("dashboard/loader.gif")}
                    alt="Loading..."
                  />
                </div>
              </div>
            ) : (
              <CommonTableNew
                caption=""
                headData={columns}
                data={displayedData}
                renderRow={(row, rowIndex) => (
                  <tr key={rowIndex}>
                    {columns.map((c) => (
                      <td key={c.key}>{(row as any)[c.key] ?? "-"}</td>
                    ))}
                  </tr>
                )}
              />
            )}
          </div>
        </CardBody>
      </Card>
      <Modal
        isOpen={monthModalOpen}
        toggle={toggleMonthModal}
        centered
        className="mt-2"
      >
        <ModalHeader toggle={toggleMonthModal}>Select Month Range</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <label>From</label>
              <select
                className="form-control"
                value={`${monthRange.from.month}-${monthRange.from.year}`}
                onChange={(e) => {
                  const [month, year] = e.target.value.split("-");
                  setMonthRange({ ...monthRange, from: { month, year } });
                }}
              >
                <option value="">Select Month</option>
                {yearOptions.flatMap((year) =>
                  Object.entries(monthNumberToName)
                    .sort(([a], [b]) => Number(b) - Number(a))
                    .filter(([monthNumber]) => {
                      if (year === currentYear) {
                        return Number(monthNumber) <= new Date().getMonth() + 1;
                      }
                      return true;
                    })
                    .map(([_, monthName]) => (
                      <option
                        key={`from-${monthName}-${year}`}
                        value={`${monthName}-${year}`}
                      >
                        {`${monthName}-${year}`}
                      </option>
                    )),
                )}
              </select>
            </Col>
            <Col md={6}>
              <label>To</label>
              <select
                className="form-control"
                value={`${monthRange.to.month}-${monthRange.to.year}`}
                onChange={(e) => {
                  const [month, year] = e.target.value.split("-");
                  setMonthRange({ ...monthRange, to: { month, year } });
                }}
              >
                <option value="">Select Month</option>
                {yearOptions.flatMap((year) =>
                  Object.entries(monthNumberToName)
                    .sort(([a], [b]) => Number(b) - Number(a))
                    .filter(([monthNumber]) => {
                      if (year === currentYear) {
                        return Number(monthNumber) <= new Date().getMonth() + 1;
                      }
                      return true;
                    })
                    .map(([_, monthName]) => (
                      <option
                        key={`to-${monthName}-${year}`}
                        value={`${monthName}-${year}`}
                      >
                        {`${monthName}-${year}`}
                      </option>
                    )),
                )}
              </select>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleMonthModal}>
            Cancel
          </Button>
          <Button
            color="danger"
            onClick={() => {
              setMonthRange({
                from: { month: "", year: "" },
                to: { month: "", year: "" },
              });
              setDateRange({ start: "", end: "" });
              toggleMonthModal();
            }}
          >
            Clear
          </Button>
          <Button color="success" onClick={handleApplyDateRange}>
            Apply
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default RCPAsalesprescription;
